/**
 * Country Overlay logic
 * Gestisce l'apertura/chiusura dell'overlay per la selezione di lingua e paese
 */

class CountryOverlay {
  constructor() {
    this.overlay = document.getElementById('country-overlay');
    if (!this.overlay) return;

    this.closeButton = this.overlay.querySelector('[data-country-overlay="close"]');
    this.backdrop = document.getElementById('backdrop-darker');

    this.init();
  }

  init() {
    // Close button
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.closeOverlay());
    }

    // Listener per aprire l'overlay
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-country-overlay-trigger]')) {
        e.preventDefault();
        this.openOverlay();
      }
    });

    // Close when another overlay opens or backdrop is clicked
    document.addEventListener('overlay:open', (e) => {
      if (e.detail.id !== 'country-overlay' && this.overlay.classList.contains('active')) {
        this.closeOverlay();
      }
    });

    document.addEventListener('overlay:closeAll', () => {
      if (this.overlay.classList.contains('active')) this.closeOverlay();
    });
  }

  openOverlay() {
    this.overlay.classList.add('active');
    document.dispatchEvent(new CustomEvent('overlay:open', { detail: { id: 'country-overlay' } }));
  }

  closeOverlay() {
    this.overlay.classList.remove('active');
    document.dispatchEvent(new CustomEvent('overlay:close', { detail: { id: 'country-overlay' } }));
  }
}

new CountryOverlay();
